// extracted by mini-css-extract-plugin
module.exports = {"venueImage":"OnTheDay-module--venueImage--lCfNI"};